import { cn } from './cn';

/**
 * <Card>
 *   <Card.Header> opcional, con titulo + acciones
 *   <Card.Body>   contenido principal
 *   <Card.Footer> acciones / botones abajo
 *
 * Estilo: surface bg, borde sutil, rounded-xl, sombra suave.
 * Hover opcional: pasar prop `hoverable` para lift en `:hover`.
 */
const Card = ({ className, hoverable, children, ...rest }) => (
    <div
        className={cn(
            'bg-surface border border-line rounded-xl shadow-soft',
            hoverable && 'transition hover:shadow-soft-lg hover:-translate-y-0.5',
            className
        )}
        {...rest}
    >
        {children}
    </div>
);

const CardHeader = ({ className, title, subtitle, actions, children, ...rest }) => (
    <div
        className={cn(
            'flex items-start justify-between gap-4 px-6 py-4 border-b border-line',
            className
        )}
        {...rest}
    >
        {(title || subtitle) ? (
            <div className="min-w-0">
                {title && <h2 className="text-base font-semibold text-text truncate">{title}</h2>}
                {subtitle && <p className="text-xs text-muted mt-0.5 truncate">{subtitle}</p>}
            </div>
        ) : children}
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
);

const CardBody = ({ className, children, ...rest }) => (
    <div className={cn('px-6 py-5', className)} {...rest}>
        {children}
    </div>
);

const CardFooter = ({ className, children, ...rest }) => (
    <div
        className={cn(
            'flex items-center justify-end gap-2 px-6 py-3 border-t border-line bg-surface-2/40 rounded-b-xl',
            className
        )}
        {...rest}
    >
        {children}
    </div>
);

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
